import React from "react";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { STRING } from "../../../../constants";

interface HeaderProps {
  onLogout: () => void;
}

export function Header({ onLogout }: HeaderProps) {
  return (
    <div className="header-container flex align-items-center justify-content-between p-3 border-bottom-1 surface-border">
      <div className="flex align-items-center" />
      <div className="flex align-items-center gap-3">
        <div className="flex align-items-center gap-2">
          <Avatar
            icon="pi pi-user"
            className="cursor-pointer hover:shadow-3 transition-all transition-duration-200"
            style={{
              background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
            }}
            title="Admin"
          />
          <div className="hidden md:block">
            <p className="m-0 text-900 font-semibold">
              {STRING.ADMIN.USER_LABEL}
            </p>
            <p className="m-0 text-600 text-sm">{STRING.ADMIN.USER_EMAIL}</p>
          </div>
        </div>
        <Button
          icon="pi pi-sign-out"
          className="p-button-text p-button-rounded"
          onClick={onLogout}
          tooltip={STRING.ADMIN.LOGOUT_TOOLTIP}
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );
}
